// eslint-disable-next-line import/no-unresolved
import { isChromium } from "..";
import { timezoneToLanguage } from "../common/constants/timezones";
import keycloak from "../keycloak";

const SUPPORTED_LANGUAGES = ["fr", "es", "en"];

const normalizeLanguage = (lang) => {
	if (!lang) {
		return null;
	}
	const normalized = lang === "esp" ? "es" : lang;
	return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
};

const resolveLanguage = (defaultLanguage) => {
	const fromDefault = normalizeLanguage(defaultLanguage);
	if (fromDefault) {
		return fromDefault;
	}
	if (typeof navigator !== "undefined" && navigator?.language) {
		const baseLang = navigator.language.toLowerCase().split("-")[0];
		const fromBrowser = normalizeLanguage(baseLang);
		if (fromBrowser) {
			return fromBrowser;
		}
		return "en";
	}
	const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return timezoneToLanguage[userTimezone] || timezoneToLanguage.default || "en";
};

const doLogin = (defaultLanguage) => {
	keycloak.login({
		redirectUri: window.location.origin,
		locale: resolveLanguage(defaultLanguage),
	});
};
const doLogout = keycloak.logout;
const getToken = () => `Bearer ${keycloak.token}`;
const clearToken = () => keycloak.clearToken();
const isLoggedIn = () => !!keycloak.token;
const updateToken = (successCallback) => keycloak.updateToken(295).then(successCallback).catch(doLogout);
const getUsername = () => keycloak.tokenParsed?.preferred_username;
const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));
const kcAll = () => keycloak;
const userLanguage = () => {
	switch (keycloak.tokenParsed?.locale) {
		case "fr":
			return "fr";
		case "es":
			return "esp";
		default:
			return "en";
	}
};

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback, defaultLanguage) => {
	if (
		!(isChromium(window.navigator) || window.env.REACT_APP_ENV === "dev" || window.env.REACT_APP_ENV === "qa") ||
		window.location.href.includes("/projects/join") ||
		window.location.href.includes("/register")
	) {
		onAuthenticatedCallback();
	} else {
		keycloak
			.init({
				checkLoginIframe: false,
				pkceMethod: "S256",
				onLoad: "check-sso",
			})
			.then((authenticated) => {
				if (authenticated) {
					if (onAuthenticatedCallback && typeof onAuthenticatedCallback === "function") {
						onAuthenticatedCallback();
					}
				} else {
					doLogin(defaultLanguage);
				}
			})
			.catch(console.error);
	}
};

const KeycloakService = {
	clearToken,
	initKeycloak,
	doLogin,
	doLogout,
	isLoggedIn,
	getToken,
	updateToken,
	getUsername,
	hasRole,
	kcAll,
	userLanguage,
};

export default KeycloakService;
